import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  constructor(private router: Router) {
  }

  user = null;
  redirectTo = '';

  public login(data) {
    localStorage.setItem('token', btoa(data));
  }

  public logout() {
    const that = this;
    localStorage.removeItem('token');
    that.setRedirect('');
    that.router.navigate(['/login']);
  }

  public isLoggedIn() {
    return localStorage.getItem('token') && localStorage.getItem('token').length > 0;
  }

  public setRedirect(to) {
    this.redirectTo = to;
  }

  public getRedirect() {
    return this.redirectTo;
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/auth.service.ts